import React from 'react';

const faNum = n => Number(n || 0).toLocaleString('fa-IR');

/** Small pager: «قبلی | صفحه X از Y | بعدی». Renders nothing on a single page. */
export default function Pager({ page, pages, onChange }) {
  if (!pages || pages <= 1) return null;
  const go = p => { if (p >= 1 && p <= pages && p !== page) onChange(p); };
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginTop: 12 }}>
      <button onClick={() => go(page - 1)} disabled={page <= 1}
        style={{ padding: '8px 18px', borderRadius: 10, border: '1.5px solid #E4E4E7', background: '#fff', fontFamily: 'inherit', fontSize: '0.8rem', fontWeight: 700, cursor: page <= 1 ? 'default' : 'pointer', opacity: page <= 1 ? 0.45 : 1 }}>
        → قبلی
      </button>
      <span style={{ fontSize: '0.78rem', color: '#71717A', fontWeight: 700, whiteSpace: 'nowrap' }}>
        صفحه {faNum(page)} از {faNum(pages)}
      </span>
      <button onClick={() => go(page + 1)} disabled={page >= pages}
        style={{ padding: '8px 18px', borderRadius: 10, border: '1.5px solid #E4E4E7', background: '#fff', fontFamily: 'inherit', fontSize: '0.8rem', fontWeight: 700, cursor: page >= pages ? 'default' : 'pointer', opacity: page >= pages ? 0.45 : 1 }}>
        بعدی ←
      </button>
    </div>
  );
}

/** Client-side slice helper: returns {items, pages} for the given 1-based page. */
export function paginate(list, page, perPage) {
  const arr = Array.isArray(list) ? list : [];
  const pages = Math.max(1, Math.ceil(arr.length / perPage));
  const p = Math.min(Math.max(1, page), pages);
  return { items: arr.slice((p - 1) * perPage, p * perPage), pages, page: p };
}
